
import { useEffect, useRef, useState } from 'react';

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const contactInfo = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      details: ['+27 78 233 3696'],
      action: 'tel:+27782333696'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      details: ['afikirc@gmail.com'],
      action: 'mailto:afikirc@gmail.com'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Location',
      details: ['KwaZulu-Natal', 'South Africa - Willing to relocate'],
      action: null
    }
  ];

  return (
    <section id="contact" ref={sectionRef} className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <div className="text-center mb-8 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 md:mb-6 font-serif">
              Let's Work Together
            </h2>
            <div className="w-24 h-1 bg-green-600 mx-auto mb-4 md:mb-6"></div>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Ready to discuss your agricultural project or explore collaboration opportunities? Get in touch today.
            </p>
          </div>

          <div className="flex justify-center">
            {/* Contact Information */}
            <div className="bg-white p-6 md:p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
              <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 md:mb-6 text-center">Contact Information</h3>
              <div className="space-y-4 md:space-y-6">
                {contactInfo.map((info, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-green-100 rounded-lg flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                      <i className={`${info.icon} text-green-600 text-lg md:text-xl`}></i>
                    </div>
                    <div className="min-w-0 flex-1">
                      <h4 className="font-semibold text-gray-800 mb-1 text-sm md:text-base">{info.title}</h4>
                      {info.details.map((detail, detailIndex) => (
                        <p key={detailIndex} className="text-gray-600 text-sm md:text-base break-words">
                          {info.action ? (
                            <a href={info.action} className="hover:text-green-600 transition-colors duration-300">
                              {detail}
                            </a>
                          ) : (
                            detail
                          )}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Call to Action Button */}
              <div className="mt-6 md:mt-8 text-center">
                <a 
                  href="mailto:afikirc@gmail.com" 
                  className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-lg hover:from-green-700 hover:to-green-800 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
                >
                  <i className="ri-mail-send-line mr-2"></i>
                  Hire Me
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
